import { useRemovePermissionsFromRoleMutation, Permission } from '../../../../../graphql'
import { useShowSuccess, useShowError } from 'hooks/useToast'

export default function useRemovePermissionHandler() {
	const [ removePermissions ] = useRemovePermissionsFromRoleMutation()
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( role: { id: number }, permission: Permission ) => {
		const roleId = role.id
		const permissions = [ permission ]

		const result = await removePermissions( { variables: { roleId, permissions } } )

		if ( result.data?.removePermissionsFromRole?.success ) {
			showSuccess( `removePermissionsFromRoleSuccess${Date.now()}`, result.data?.removePermissionsFromRole?.message ?? 'Successfully removed permission!' )
		} else {
			showError( `removePermissionsFromRoleError${Date.now()}`, result.data?.removePermissionsFromRole?.message ?? 'Sorry, an error occurred' )
		}
	}
}
